import type { ReactNode } from 'react';

export const symbol_adf_scanner: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-220v-158q0-45 27.5-72.5T180-478h62v-262q0-24.75 17.63-42.38Q277.25-800 302-800h356q24.75 0 42.38 17.62Q718-764.75 718-740v262h62q45 0 72.5 27.5T880-378v158q0 24.75-17.62 42.37Q844.75-160 820-160H140q-24.75 0-42.37-17.63Q80-195.25 80-220Zm222-258h356v-262H302v262ZM140-220h680v-158q0-20-10-30t-30-10H180q-20 0-30 10t-10 30v158Zm599.18-103q12.82 0 21.32-8.68 8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5ZM140-418h680-680Z"
		/>
	</svg>
);
